// extracted by mini-css-extract-plugin
export default {"color":"ResetPassword_color__BDcN0","options":"ResetPassword_options__iNmzM","link":"ResetPassword_link__ZbQ-T"};